export const subscriptionStatusOptions = [
    { label: "Active", value: "1" },
    { label: "Inactive", value: "0" },
]